var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({attrs:{"value":_vm.texto,"type":"text","inputmode":"decimal"},on:{"input":_vm.digitar,"focus":function($event){_vm.focado = true},"blur":_vm.sair}},'v-text-field',_vm.$attrs,false),_vm.ouvintes))}
var staticRenderFns = []

export { render, staticRenderFns }